import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import DataTable from '../DataTable';
import ConfirmDeleteModal from '../ConfirmDeleteModal';
import SearchSpecificReview from './SearchSpecificReview';
import SpecificReviewCategoriesTable from './SpecificReviewCategoriesTable';
import CreateSpecificReviewCategoryModal from './CreateSpecificReviewCategoryModal';
import PoolSpecificReviewCategoriesTable from './PoolSpecificReviewCategoriesTable';
import CreatePoolSpecificReviewCategoryModal from './CreatePoolSpecificReviewCategoryModal';
import AssignSpecificReviewCategoryToPoolCategoryModal from './AssignSpecificReviewCategoryToPoolCategoryModal';

const SpecificReviewCategoriesMain = ({ render, setRender, data, rows, setPassSelectedCategoryId, columns, onAssignToReview, handleAttachAllGMBLink }) => {
    const [rowsData, setRowsData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [poolCategories, setPoolCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('all');
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isPoolCreateModalOpen, setIsPoolCreateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [delCategoryId, setDelCategoryId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [delData, setDeleteData] = useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
    const [selectedCategoryForReview, setSelectedCategoryForReview] = useState(null);
    const [isAssignPoolSpecificReviewCategoryModalOpen, setIsAssignPoolSpecificReviewCategoryModalOpen] = useState(false);
    


    useEffect(() => {
        setRowsData(rows);
        fetchCategories();
        fetchPoolCategories();
        loadColumnVisibility();
    }, [render]);

    useEffect(() => {
        handleCategorySelect(selectedCategoryId);
    }, [render]);

    const handleBulkDelete = async (deleteData) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}specific-review/bulk-delete`, { reviewIds: deleteData },{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success(response.data.message || 'Selected reviews deleted successfully');
            setRender(prev => !prev);
        } catch (error) {
            toast.error(error.response.data.message || 'Failed to delete selected reviews');
        }
    };

    const handleDeleteCategory = async (categoryId) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}specific-review-category/delete/${categoryId}`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success(response.data.message || 'Category deleted successfully');
            setRender(prev => !prev);
        } catch (error) {
            toast.error('Failed to delete category');
        }
    };

    const handleDeletePoolCategory = async (categoryId) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}pool-specific-review-category/delete/${categoryId}`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success(response.data.message || 'Category deleted successfully');
            setRender(prev => !prev);
        } catch (error) {
            toast.error('Failed to delete category');
        }
    };

    const ConfirmHandleDelete = (deleteData) => {
        setIsDeleteModalOpen(true);
        setDeleteData(deleteData);
    };

    const handleDeleteConfirm = () => {
        setIsDeleteModalOpen(false);
        handleBulkDelete(delData);
    };

    const handleAssignPoolSpecificReviewCategory = (category) => {
        setSelectedCategoryForReview(category)
        setIsAssignPoolSpecificReviewCategoryModalOpen(true);
    }

    const handleCloseAssignPoolSpecificReviewCategory = () => {
        setIsAssignPoolSpecificReviewCategoryModalOpen(false);
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}specific-review-category/all-categories`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setCategories(response.data);
        } catch (error) {
            toast.error('Failed to fetch categories');
        }
    };

    const fetchPoolCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}pool-specific-review-category/all-categories`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setPoolCategories(response.data);
        } catch (error) {
            toast.error('Failed to fetch categories');
        }
    };

    
    const fetchCategoryByPool = async (categoryId) => {
        try {
            const url = `${process.env.REACT_APP_BASE_URL}pool-specific-review-category/${categoryId}/reviews`;
            const response = await axios.get(url,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setCategories(response.data.specificReviewsCategory);
        } catch (error) {
            toast.error('Failed to fetch reviews by category');
        }
    };

    const fetchReviewsByCategory = async (categoryId, page = 1, limit = 100) => {
        try {
            const url = `${process.env.REACT_APP_BASE_URL}specific-review-category/${categoryId}/reviews?page=${page}&limit=${limit}`;
            const response = await axios.get(url,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setTotalPages(response.data.totalPages);
            setCurrentPage(response.data.currentPage);
            setTotalItems(response.data.totalItems);

            const flattenReviews = response.data.specificReviews.map((row) => ({
                id: row._id,
                _id: row._id,
                reviewText: row.reviewText,
                searchKeyword: row.searchKeyword,
                location: row.location,
                rating: row.rating,
                pbsLink: row.pbsLink,

            }));

            setRowsData(flattenReviews);
        } catch (error) {
            toast.error('Failed to fetch reviews by category');
        }
    };

    const setSearchReview = (reviewData) => {
        setTotalPages(reviewData.totalPages);
        setCurrentPage(reviewData.currentPage);
        setTotalItems(reviewData.totalItems);

        const flattenReviews = reviewData.specificReviews.map((row) => ({
            id: row._id,
            _id: row._id,
            reviewText: row.reviewText,
            searchKeyword: row.searchKeyword,
            location: row.location,
            rating: row.rating,
            pbsLink: row.pbsLink,

        }));

        setRowsData(flattenReviews);

    }
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchReviewsByCategory(selectedCategoryId, newPage);
    };

    const handleCategorySelect = (categoryId) => {
        setCurrentPage(1);
        setSelectedCategoryId(categoryId);
        setPassSelectedCategoryId(categoryId);
        fetchReviewsByCategory(categoryId, 1);
    };

    const handlePoolCategorySelect = (categoryId) => {
        fetchCategoryByPool(categoryId);
    };

    const loadColumnVisibility = () => {
        const storedVisibility = localStorage.getItem('specificReviewColumnVisibility');
        if (storedVisibility) {
            setColumnVisibilityModel(JSON.parse(storedVisibility));
        }
    };

    const saveColumnVisibility = (model) => {
        localStorage.setItem('specificReviewColumnVisibility', JSON.stringify(model));
        setColumnVisibilityModel(model);
    };

    return (
        <div>
            <SearchSpecificReview setSearchReview={setSearchReview} />
            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                <div style={{ flex: 2, marginRight: "20px" }}>
                    <PoolSpecificReviewCategoriesTable onCategorySelect={handlePoolCategorySelect} categories={poolCategories} handleDeleteCategory={handleDeletePoolCategory}/>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            style={{ width: "130px", height: "50px", padding: "10px", margin: "1rem 0", backgroundColor: '#1B3C73', color: "white" }}
                            variant="outlined"
                            size="small"
                            onClick={() => setIsPoolCreateModalOpen(true)}
                        >
                           Pool
                        </Button>
                    </div>

                    <SpecificReviewCategoriesTable onCategorySelect={handleCategorySelect} categories={categories} handleDeleteCategory={handleDeleteCategory} handleAssignPoolSpecificReviewCategory={handleAssignPoolSpecificReviewCategory}/>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            style={{ width: "130px", height: "50px", padding: "10px", marginTop: "15px", backgroundColor: '#1B3C73', color: "white" }}
                            variant="outlined"
                            size="small"
                            onClick={() => setIsCreateModalOpen(true)}
                        >
                            Category
                        </Button>
                    </div>
                </div>
                <div style={{ flex: 10 }}>
                    {data.length > 0 && rowsData.length > 0 ? (
                        <DataTable rows={rowsData} columns={columns} onDeleteSelected={ConfirmHandleDelete} onAssignToReview={onAssignToReview} handlePageChange={handlePageChange} currentPage={currentPage} totalPages={totalPages} totalItems={totalItems} saveColumnVisibility={saveColumnVisibility} columnVisibilityModel={columnVisibilityModel} onAttachAllGMBLink={handleAttachAllGMBLink} attachAllGMBLink={true} />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <CreateSpecificReviewCategoryModal
                open={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                fetchCategories={fetchCategories}
            />
            <CreatePoolSpecificReviewCategoryModal
                open={isPoolCreateModalOpen}
                onClose={() => setIsPoolCreateModalOpen(false)}
                fetchPoolCategories={fetchPoolCategories}
            />
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <ConfirmDeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteConfirm}
                message="Are you sure you want to delete this review?"
            />
            {isAssignPoolSpecificReviewCategoryModalOpen && (
                <AssignSpecificReviewCategoryToPoolCategoryModal
                    open={isAssignPoolSpecificReviewCategoryModalOpen}
                    onClose={handleCloseAssignPoolSpecificReviewCategory}
                    category={selectedCategoryForReview}
                />
            )}
        </div>
    );
};

export default SpecificReviewCategoriesMain;

